namespace GeniuzPOS.QRreport {
    export enum WMYfg {
        Week = 0,
        Month = 1,
        Year = 2
    }
    Serenity.Decorators.registerEnumType(WMYfg, 'GeniuzPOS.QRreport.WMYfg');
}
